<template>
    <div>
        <a-tabs   @change="callback">
            <a-tab-pane key="1" tab="谷歌注册信息">
                <Google/>
            </a-tab-pane>
            <a-tab-pane key="2" tab="FB注册信息">
                <Facebook/>
            </a-tab-pane>
        </a-tabs>
    </div>
</template>

<script>
    import API from "./api";
    import Google from "./components/google"
    import Facebook from "./components/facebook"


    export default {
        name: "index",
        data() {
            return {

            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/WebsiteDetection/AdvertisingRecords"; //设置左侧导航2-2 active
        },
        mounted() {
        },
        components: {Google,Facebook},
        methods: {
            callback(key) {
            },
        }
    }
</script>

<style scoped>
    .seachBox .seachList .name {
        width: 70px !important;
    }

    .seachBox .seachList .seachs {
        width: calc(100% - 80px);
    }

    .inputs {
        display: inline-block;
        width: 70px
    }
</style>